export default [
  {
    path: '/tools/:key?',
    name: 'toolsPage',
    component: () => import(/*webpackChunkName:'tools'*/ '@/views/tools/index.vue'),
    meta: {},
  },
];
